import { gql, gqlFetch } from '@/service/gql'
import { trackFieldsFrag } from '@/track/trackFieldsFrag'
import { getAuth } from '@/auth/authRef'
import { toRecommendationModel, type RecommendationModel } from '@/browse/recommendationModel'
import { notNull } from '@amzn/shiv'

const albumTracksQuery = gql(
    `
        query albumTracks($id: String!, $isAuthenticated: Boolean!) {
            album(id: $id) {
                id
                title
                tracks {
                    ...trackFields
                }
            }
        }
    `,
    [trackFieldsFrag]
)

export async function fetchAlbumTracks(
    albumId: string
): Promise<{ title: string; tracks: readonly RecommendationModel[] }> {
    const result = await gqlFetch(albumTracksQuery, {
        id: albumId,
        isAuthenticated: getAuth().isSignedIn(),
    })
    const tracks = (result.album?.tracks ?? []).map((t) => toRecommendationModel(t)).filter(notNull)
    return { title: result.album?.title ?? '', tracks }
}

const artistTracksQuery = gql(
    `
        query artistTracks($id: String!, $isAuthenticated: Boolean!) {
            artist(id: $id) {
                id
                name
                tracks {
                    edges {
                        node {
                            ...trackFields
                        }
                    }
                }
            }
        }
    `,
    [trackFieldsFrag]
)

export async function fetchArtistTracks(
    artistId: string
): Promise<{ title: string; tracks: readonly RecommendationModel[] }> {
    const result = await gqlFetch(artistTracksQuery, {
        id: artistId,
        isAuthenticated: getAuth().isSignedIn(),
    })
    const edges = result.artist?.tracks?.edges ?? []
    const tracks = edges.map((e) => toRecommendationModel(e.node)).filter(notNull)
    return { title: result.artist?.name ?? '', tracks }
}
